import { Utils } from "../../shared/utils";

export class ExpensesRecievedConst {
  public static headerTable = [
    {
      field: 'invoiceNumber', title: 'Gasto',
      cell: (row) => `${row.invoiceNumber}`, class: (row) => row.asientoContable ? 'paid' : 'notPaid'
    },
    {
      field: 'issuerName', title: 'Emisor', cell: (row) => `${row.issuerName}`,
      class: (row) => {
        if (row.issuerName === 'HA-ConvFact SL') {
          return `icon-expenseByConvfact`;
        }
      }
    },
    {
      field: 'invoiceRelease', title: 'Fecha', cell: (row) =>
        `${new Date(row.invoiceRelease).toLocaleDateString()}`, class: (row) => ``
    },
    { field: 'total', title: 'Total', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => row.paided ? `paid` : `notPaid` },
    {
      field: 'paided', title: 'Pagado', cell: (row) =>
        row.paided ? `${new Date(row.paided).toLocaleDateString()}` : Utils.FormatMoney(row.totalPaided) + ' €', class: (row) => ``
    },
    {
      field: 'comments',
      title: 'Observaciones',
      cell: (row) => {
        let text = '';

        if (row && row.comments) {
          text = String(row.comments);
        }

        if (!text) {
          return '';
        }

        if (text.length > 15) {
          return text.substring(0, 15) + '...';
        }

        return text;
      },
      tooltip: (row) => {
        if (row && row.comments) {
          return String(row.comments);
        }

        return '';
      },
      class: (row) => ``
    },
    { field: 'exportedToExcel', title: 'Excel Cont.', cell: (row) => row.exportedToExcel ? 'Si' : 'No', class: (row) => row.exportedToExcel ? `` : `` }
  ];
}

export class ExpensesSalaryConst {

  public static headerTable = [
    {
      field: 'employee_name',
      title: 'Empleado',
      cell: (row) => {
        const employeeName = row.employee_name || 'Nombre Desconocido';
        return `${employeeName}`;
      },
      class: (row) => ``,
    },
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'salaryBrut', title: 'Bruto', cell: (row) => Utils.FormatMoney(row.salaryBrut) + ' €', class: (row) => `` },
    { field: 'salaryNet', title: 'Neto', cell: (row) => Utils.FormatMoney(row.salaryNet) + ' €', class: (row) => `` },
    { field: 'irpf', title: 'IRPF', cell: (row) => `${row.irpf}`, class: (row) => `` },
    {
      field: 'segSocialCompany', title: 'SegSocial Compañia', cell: (row) => `${row.segSocialCompany}`,
      class: (row) => ``
    },
    {
      field: 'segSocialWorker', title: 'SegSocial Trabajador', cell: (row) => `${row.segSocialWorker}`,
      class: (row) => ``
    },
    {
      field: 'paidedSalaries', title: 'Pago Nómina', cell: (row) =>
        row.paidedSalaries != 0 ? `${isNaN(Date.parse(row.paidedSalaries)) ? row.paidedSalaries : row.paidedSalaries}` : '0,00 €', class: (row) => ``
    },
    {
      field: 'paidedSegSo', title: 'Pago Seg. S', cell: (row) =>
        row.paidedSegSo != 0 ? `${isNaN(Date.parse(row.paidedSegSo)) ? row.paidedSegSo : row.paidedSegSo}` : '0,00 €', class: (row) => ``
    },
  ];
}

export class ExpensesImportSalaryConst {
  public static headerTable = [
    { field: 'concept', title: 'Concepto', cell: (row) => `${row.concept}`, class: (row) => `` },
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },
    { field: 'salaryBrut', title: 'Bruto', cell: (row) => Utils.FormatMoney(row.salaryBrut) + ' €', class: (row) => `` },
    { field: 'salaryInKind', title: 'Salario en especie', cell: (row) => Utils.FormatMoney(row.salaryInKind) + ' €', class: (row) => `` },
    { field: 'irpf', title: 'IRPF', cell: (row) => `${row.irpf}`, class: (row) => `` },
    { field: 'paided', title: 'Fecha de pago', cell: (row) => `${new Date(row.paided).toLocaleDateString()}`, class: (row) => `` },
    {
      field: 'segSocialWorker', title: 'SegSocial Trabajador', cell: (row) => `${row.segSocialWorker}`,
      class: (row) => ``
    },
    { field: 'otherDeductions', title: 'Otras deducciones', cell: (row) => Utils.FormatMoney(row.otherDeductions) + ' €', class: (row) => `` },
    { field: 'advancePayments', title: 'Anticipos', cell: (row) => Utils.FormatMoney(row.advancePayments) + ' €', class: (row) => `` },
    {
      field: 'segSocialCompany', title: 'SegSocial Compañia', cell: (row) => `${row.segSocialCompany}`,
      class: (row) => ``
    },
    { field: 'salaryNet', title: 'Neto', cell: (row) => Utils.FormatMoney(row.salaryNet) + ' €', class: (row) => `` },
  ];
}

export class ExpensesSelfEmployedConst {
  public static headerTable = [
    { field: 'concept', title: 'Concepto', cell: (row) => `${row.concept}`, class: (row) => `` },
    {
      field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => ``
    },
    { field: 'amount', title: 'Cantidad', cell: (row) => Utils.FormatMoney(row.amount) + ' €', class: (row) => `` }
  ];
}

export class ExpensesAdvancedPaymentConst {
  public static headerTable = [
    { field: 'providerName', title: 'Proveedor', cell: (row) => `${row.providerName}`, class: (row) => `` },
    {
      field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`,
      class: (row) => ``
    },
    { field: 'total', title: 'Cantidad', cell: (row) => Utils.FormatMoney(row.total) + ' €', class: (row) => `` },
    {
      field: 'expenseNumber', title: 'Gasto asignado', cell: (row) => row.expenseNumber != null ? row.expenseNumber : '',
      class: (row) => ``
    }
  ];
}

export class ExpensesIrpfListConst {
  public static headerTable = [
    {
      field: 'invoiceNumber', title: 'Número factura', cell: (row) => `${row.invoiceNumber}`,
      class: (row) => ``
    },
    { field: 'issuer', title: 'Emisor', cell: (row) => `${row.issuer}`, class: (row) => `` },
    { field: 'issuerVat', title: 'CIF/NIF', cell: (row) => `${row.issuerVat}`, class: (row) => `` },
    {
      field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`,
      class: (row) => ``
    },
    { field: 'base', title: 'Base', cell: (row) => Utils.FormatMoney(row.base) + ' €', class: (row) => `` },
    { field: 'percent', title: 'IRPF', cell: (row) => `${row.percent}`, class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => Utils.FormatMoney(row.amount) + ' €', class: (row) => `` }
  ];
}

export class InvoicesIrpfListConst {
  public static headerTable = [
    {
      field: 'invoiceNumber', title: 'Número factura', cell: (row) => `${row.invoiceNumber}`,
      class: (row) => ``
    },
    { field: 'receiver', title: 'Destinatario', cell: (row) => `${row.receiver}`, class: (row) => `` },
    { field: 'receiverVat', title: 'CIF/NIF', cell: (row) => `${row.receiverVat}`, class: (row) => `` },
    {
      field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`,
      class: (row) => ``
    },
    { field: 'base', title: 'Base', cell: (row) => Utils.FormatMoney(row.base) + ' €', class: (row) => `` },
    { field: 'percent', title: 'IRPF', cell: (row) => `${row.percent}`, class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => Utils.FormatMoney(row.amount) + ' €', class: (row) => `` }
  ];
}

export class ExpensesBankChargesConst {
  public static headerTable = [
    { field: 'concept', title: 'Concepto', cell: (row) => `${row.concept}`, class: (row) => `` },
    {
      field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => ``
    },
    { field: 'amount', title: 'Cantidad', cell: (row) => row.amount, class: (row) => `` },
  ];
}

export const TYPE_PAYMENTS: { [key: string]: number } = {
  'Efectivo': 1,
  'Transferencia bancaria': 3,
  'Remesa en cuenta': 5
};
